



















































import { Vue, Component, Prop } from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { StoreType, PartnerHsaStoreInfo } from "@/shared/types";
import * as Constants from "@/admin/constants";

@Component({
  components: {
    Input,
    ErrorSummary
  },
})
export default class StoreConfiguration extends Vue {
  $router: VueRouter;
  $validator: Validator;

  featureFlagStore = useFeatureFlagStore();
  isSubmitting = false;
  storeType = StoreType;

  storeTypeDisplay: Record<StoreType, string> = {
    [StoreType.noStore]: "No Store",
    [StoreType.hsaStore]: "HSA Store",
    [StoreType.amazonMarketPlace]: "Amazon Marketplace",
  };
  storeTypeOptions = this.storeTypeDisplay;

  storeInfo: PartnerHsaStoreInfo = {
    storeType: StoreType.amazonMarketPlace,
    storeLink: Constants.AmazonHsaStoreLink,
    eligibilityLink: Constants.HSABankQMELink
  };

  isLoaded = false;

  @Prop() originalStoreInfo: PartnerHsaStoreInfo;

  updateStoreDefaults () {
    if (this.originalStoreInfo && this.originalStoreInfo.storeType === this.storeInfo.storeType) {
        this.storeInfo = { ...this.originalStoreInfo };
    }
    else {
        switch (this.storeInfo.storeType) {
            case StoreType.noStore: {
                this.storeInfo.storeLink = null;
                this.storeInfo.eligibilityLink = Constants.HSABankQMELink;
                break;
            }
            case StoreType.amazonMarketPlace: {
                this.storeInfo.storeLink = Constants.AmazonHsaStoreLink;
                this.storeInfo.eligibilityLink  = Constants.HSABankQMELink;
                break;
            }
            case StoreType.hsaStore: {
                this.storeInfo.storeLink = Constants.HsaStoreDefaultStoreLink;
                this.storeInfo.eligibilityLink  = Constants.HsaStoreDefaultEligibilityLink;
                break;
            }
            default:
                break;
        }
    }
  }
}
